<template lang="pug">
div
  #preloader(v-if="gameLaunching|| favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2(v-if="favList.length>0")
      template(v-for="game in filteredList()")
        .gggl
          a(href='javascript:void(0)' @click="launchGame(game.game_code, game.provider_code,game.game_type, game.game_name)")
            .iimg
              img(:src='game.img_url')
          .prov
            img(:src="`/new/img/provider/${game.provider_code}.png`")
          .fav.aaa
            i.fa-solid.fa-heart.pointer( @click="removeFav(game.provider_code,game.game_code)")
          .name {{game.game_name}}
    template(v-else)
      .text-center.text-white.my-4.w-100
        i.fa-regular.fa-newspaper.display-6.text-black
        .text-black No data
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
export default {
	props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
	data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      items:[],
      offList:[],
      // searchinput: "",
      favListAction: false,
			path:"",
      mobileDevice: false,
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
		favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "BINGO")
		}
  },
  mounted(){
    this.getMobile()
  },
	methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
		removeFav(provider, game){
			if (this.sessionToken) {
				this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
						this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
						this.favListAction = false
          });
      }
		},
		launchGame(game, provider_code, type, name){
			if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
				var game_code = game
        var lang_code = "en"
        var provider = provider_code
        var game_type = type
				var player_id = this.accountID
        var auth_token = this.sessionToken
        var mobile = this.mobileDevice
        var game_name = name
				switch(provider_code){
					case "FC":
						this.path = "user/launchFc"
						break;
          case "JILI2":
            this.path = "user/launchJili"
            break;
					default:
						this.path = "user/launchAwc"
						break;
				}
        this.$store
          .dispatch(this.path, { player_id, auth_token,game_code, lang_code, provider, game_type, mobile, game_name })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				$("#logModal").modal("show")
			}
		},
		filteredList(){
      return this.favList.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
	}
}
</script>